<div class="flex flex-col">
    {{ params.status }}
    @if (params.concurrenceDate && params.releaseDate) {
        <div>
            Notice Date: {{ formatDateToMMDDYYYY(params.concurrenceDate) }} -
            Release Date: {{ formatDateToMMDDYYYY(params.releaseDate) }}
        </div>
    }
</div>
